import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { BaseRichService } from '../providers/base-rich.service';

@Injectable()
export class AccessGuard implements CanActivate {
  constructor(public service: BaseRichService) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const menusStr = sessionStorage.getItem('menus');
    if (menusStr) {
      const menus = JSON.parse(menusStr);
      return this.hasAccess(menus, state);
    } else {
      try {
        const menus = await this.service.menu(this.service.selectedAccount).toPromise();
        sessionStorage.setItem('menus', JSON.stringify(menus));
        return this.hasAccess(menus, state);
      } catch (error) {
        console.error(error);
        return false;
      }
    }
  }

  hasAccess(menus, state) {
    for (const menu of menus) {
      if (menu.url === state.url) {
        return true;
      } else if (menu.children) {
        for (const child of menu.children) {
          if (child.url === state.url) {
            return true;
          }
        }
      }
    }
    return false;
  }

}

